/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  AdjustmentSelectOptionsData
} from '../../model/adjustmentSelectOptionsData'
import type {
  AdjustmentSubEventCreateAPIDataRequest
} from '../../model/adjustmentSubEventCreateAPIDataRequest'
import type {
  AdjustmentSubEventReadAPIData
} from '../../model/adjustmentSubEventReadAPIData'
import type {
  AdjustmentSubEventSelectOptionsRetrieveParams
} from '../../model/adjustmentSubEventSelectOptionsRetrieveParams'
import type {
  FundFamilyEventAdjustmentCreateData
} from '../../model/fundFamilyEventAdjustmentCreateData'
import type {
  FundFamilyEventAdjustmentCreateDataRequest
} from '../../model/fundFamilyEventAdjustmentCreateDataRequest'
import type {
  FundFamilyEventCommitmentsAdjustmentCreateData
} from '../../model/fundFamilyEventCommitmentsAdjustmentCreateData'
import type {
  FundFamilyEventCommitmentsAdjustmentCreateDataRequest
} from '../../model/fundFamilyEventCommitmentsAdjustmentCreateDataRequest'
import type {
  FundFamilyEventCommitmentsAdjustmentCreateShadowDataRequest
} from '../../model/fundFamilyEventCommitmentsAdjustmentCreateShadowDataRequest'
import type {
  FundFamilyEventData
} from '../../model/fundFamilyEventData'
import type {
  FundFamilySubEventAdjustmentRetrieveParams
} from '../../model/fundFamilySubEventAdjustmentRetrieveParams'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Lists adjustments for a particular sub event type of a fund family event
 */
export const fundFamilySubEventAdjustmentRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventAdjustmentRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<AdjustmentSubEventReadAPIData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event-admin/${fundFamilyEventId}/adjustment-sub-event`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFundFamilySubEventAdjustmentRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventAdjustmentRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event-admin/${fundFamilyEventId}/adjustment-sub-event`, ...(params ? [params]: [])] as const;
    }

    
export const getFundFamilySubEventAdjustmentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilySubEventAdjustmentRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventAdjustmentRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventAdjustmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilySubEventAdjustmentRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilySubEventAdjustmentRetrieve>>> = ({ signal }) => fundFamilySubEventAdjustmentRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventAdjustmentRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilySubEventAdjustmentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilySubEventAdjustmentRetrieve>>>
export type FundFamilySubEventAdjustmentRetrieveQueryError = unknown

export const useFundFamilySubEventAdjustmentRetrieve = <TData = Awaited<ReturnType<typeof fundFamilySubEventAdjustmentRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventAdjustmentRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventAdjustmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilySubEventAdjustmentRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilySubEventAdjustmentRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilySubEventAdjustmentRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventAdjustmentRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventAdjustmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilySubEventAdjustmentRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilySubEventAdjustmentRetrieve>>> = ({ signal }) => fundFamilySubEventAdjustmentRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventAdjustmentRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilySubEventAdjustmentRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilySubEventAdjustmentRetrieve>>>
export type FundFamilySubEventAdjustmentRetrieveSuspenseQueryError = unknown

export const useFundFamilySubEventAdjustmentRetrieveSuspense = <TData = Awaited<ReturnType<typeof fundFamilySubEventAdjustmentRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventAdjustmentRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventAdjustmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilySubEventAdjustmentRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilySubEventAdjustmentRetrieveLoader = (queryParamsOrFn?: (FundFamilySubEventAdjustmentRetrieveParams | ((params: Params) => FundFamilySubEventAdjustmentRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilySubEventAdjustmentRetrieveQueryKey(fundFamilyId,fundFamilyEventId, queryParams),
              queryFn: () => fundFamilySubEventAdjustmentRetrieve(fundFamilyId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Upserts an adjustment sub event to adjust a particular sub event type of a draft fund family event
 */
export const fundFamilySubEventAdjustmentUpsert = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    adjustmentSubEventCreateAPIDataRequest: AdjustmentSubEventCreateAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event-admin/${fundFamilyEventId}/adjustment-sub-event`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adjustmentSubEventCreateAPIDataRequest
    },
      options);
    }
  


export const getFundFamilySubEventAdjustmentUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilySubEventAdjustmentUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: AdjustmentSubEventCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilySubEventAdjustmentUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: AdjustmentSubEventCreateAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilySubEventAdjustmentUpsert>>, {fundFamilyId: string;fundFamilyEventId: string;data: AdjustmentSubEventCreateAPIDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,data} = props ?? {};

          return  fundFamilySubEventAdjustmentUpsert(fundFamilyId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilySubEventAdjustmentUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilySubEventAdjustmentUpsert>>>
    export type FundFamilySubEventAdjustmentUpsertMutationBody = AdjustmentSubEventCreateAPIDataRequest
    export type FundFamilySubEventAdjustmentUpsertMutationError = unknown

    export const useFundFamilySubEventAdjustmentUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilySubEventAdjustmentUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: AdjustmentSubEventCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilySubEventAdjustmentUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get select form-field options for adjustments
 */
export const adjustmentSubEventSelectOptionsRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    params?: AdjustmentSubEventSelectOptionsRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<AdjustmentSelectOptionsData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event-admin/${fundFamilyEventId}/adjustment-sub-event-select-options`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAdjustmentSubEventSelectOptionsRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    params?: AdjustmentSubEventSelectOptionsRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event-admin/${fundFamilyEventId}/adjustment-sub-event-select-options`, ...(params ? [params]: [])] as const;
    }

    
export const getAdjustmentSubEventSelectOptionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adjustmentSubEventSelectOptionsRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: AdjustmentSubEventSelectOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adjustmentSubEventSelectOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdjustmentSubEventSelectOptionsRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adjustmentSubEventSelectOptionsRetrieve>>> = ({ signal }) => adjustmentSubEventSelectOptionsRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adjustmentSubEventSelectOptionsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdjustmentSubEventSelectOptionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adjustmentSubEventSelectOptionsRetrieve>>>
export type AdjustmentSubEventSelectOptionsRetrieveQueryError = unknown

export const useAdjustmentSubEventSelectOptionsRetrieve = <TData = Awaited<ReturnType<typeof adjustmentSubEventSelectOptionsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: AdjustmentSubEventSelectOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adjustmentSubEventSelectOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAdjustmentSubEventSelectOptionsRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAdjustmentSubEventSelectOptionsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof adjustmentSubEventSelectOptionsRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: AdjustmentSubEventSelectOptionsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adjustmentSubEventSelectOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdjustmentSubEventSelectOptionsRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adjustmentSubEventSelectOptionsRetrieve>>> = ({ signal }) => adjustmentSubEventSelectOptionsRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof adjustmentSubEventSelectOptionsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AdjustmentSubEventSelectOptionsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof adjustmentSubEventSelectOptionsRetrieve>>>
export type AdjustmentSubEventSelectOptionsRetrieveSuspenseQueryError = unknown

export const useAdjustmentSubEventSelectOptionsRetrieveSuspense = <TData = Awaited<ReturnType<typeof adjustmentSubEventSelectOptionsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: AdjustmentSubEventSelectOptionsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adjustmentSubEventSelectOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAdjustmentSubEventSelectOptionsRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getAdjustmentSubEventSelectOptionsRetrieveLoader = (queryParamsOrFn?: (AdjustmentSubEventSelectOptionsRetrieveParams | ((params: Params) => AdjustmentSubEventSelectOptionsRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getAdjustmentSubEventSelectOptionsRetrieveQueryKey(fundFamilyId,fundFamilyEventId, queryParams),
              queryFn: () => adjustmentSubEventSelectOptionsRetrieve(fundFamilyId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get fund family event commitments adjustment
 */
export const fundFamilyEventCommitmentsAdjustmentRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundFamilyEventCommitmentsAdjustmentCreateData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event-admin/${fundFamilyEventId}/commitments-adjustment`, method: 'GET', signal
    },
      options);
    }
  

export const getFundFamilyEventCommitmentsAdjustmentRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event-admin/${fundFamilyEventId}/commitments-adjustment`] as const;
    }

    
export const getFundFamilyEventCommitmentsAdjustmentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyEventCommitmentsAdjustmentRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentRetrieve>>> = ({ signal }) => fundFamilyEventCommitmentsAdjustmentRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyEventCommitmentsAdjustmentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentRetrieve>>>
export type FundFamilyEventCommitmentsAdjustmentRetrieveQueryError = unknown

export const useFundFamilyEventCommitmentsAdjustmentRetrieve = <TData = Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyEventCommitmentsAdjustmentRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilyEventCommitmentsAdjustmentRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyEventCommitmentsAdjustmentRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentRetrieve>>> = ({ signal }) => fundFamilyEventCommitmentsAdjustmentRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyEventCommitmentsAdjustmentRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentRetrieve>>>
export type FundFamilyEventCommitmentsAdjustmentRetrieveSuspenseQueryError = unknown

export const useFundFamilyEventCommitmentsAdjustmentRetrieveSuspense = <TData = Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyEventCommitmentsAdjustmentRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilyEventCommitmentsAdjustmentRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilyEventCommitmentsAdjustmentRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => fundFamilyEventCommitmentsAdjustmentRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Adjusts a fund family event
 */
export const fundFamilyEventCommitmentsAdjustmentCreate = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilyEventCommitmentsAdjustmentCreateDataRequest: FundFamilyEventCommitmentsAdjustmentCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyEventData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event-admin/${fundFamilyEventId}/commitments-adjustment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fundFamilyEventCommitmentsAdjustmentCreateDataRequest
    },
      options);
    }
  


export const getFundFamilyEventCommitmentsAdjustmentCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventCommitmentsAdjustmentCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventCommitmentsAdjustmentCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentCreate>>, {fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventCommitmentsAdjustmentCreateDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,data} = props ?? {};

          return  fundFamilyEventCommitmentsAdjustmentCreate(fundFamilyId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyEventCommitmentsAdjustmentCreateMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentCreate>>>
    export type FundFamilyEventCommitmentsAdjustmentCreateMutationBody = FundFamilyEventCommitmentsAdjustmentCreateDataRequest
    export type FundFamilyEventCommitmentsAdjustmentCreateMutationError = unknown

    export const useFundFamilyEventCommitmentsAdjustmentCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventCommitmentsAdjustmentCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyEventCommitmentsAdjustmentCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Adjusts a fund family event via shadow
 */
export const fundFamilyEventCommitmentsAdjustmentShadowCreate = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilyEventCommitmentsAdjustmentCreateShadowDataRequest: FundFamilyEventCommitmentsAdjustmentCreateShadowDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyEventData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event-admin/${fundFamilyEventId}/commitments-adjustment-shadow`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fundFamilyEventCommitmentsAdjustmentCreateShadowDataRequest
    },
      options);
    }
  


export const getFundFamilyEventCommitmentsAdjustmentShadowCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentShadowCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventCommitmentsAdjustmentCreateShadowDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentShadowCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventCommitmentsAdjustmentCreateShadowDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentShadowCreate>>, {fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventCommitmentsAdjustmentCreateShadowDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,data} = props ?? {};

          return  fundFamilyEventCommitmentsAdjustmentShadowCreate(fundFamilyId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyEventCommitmentsAdjustmentShadowCreateMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentShadowCreate>>>
    export type FundFamilyEventCommitmentsAdjustmentShadowCreateMutationBody = FundFamilyEventCommitmentsAdjustmentCreateShadowDataRequest
    export type FundFamilyEventCommitmentsAdjustmentShadowCreateMutationError = unknown

    export const useFundFamilyEventCommitmentsAdjustmentShadowCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventCommitmentsAdjustmentShadowCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventCommitmentsAdjustmentCreateShadowDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyEventCommitmentsAdjustmentShadowCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get fund family event adjustment
 */
export const fundFamilyEventAdjustmentRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundFamilyEventAdjustmentCreateData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event-admin/${fundFamilyEventId}/event-adjustment`, method: 'GET', signal
    },
      options);
    }
  

export const getFundFamilyEventAdjustmentRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event-admin/${fundFamilyEventId}/event-adjustment`] as const;
    }

    
export const getFundFamilyEventAdjustmentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyEventAdjustmentRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventAdjustmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyEventAdjustmentRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyEventAdjustmentRetrieve>>> = ({ signal }) => fundFamilyEventAdjustmentRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventAdjustmentRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyEventAdjustmentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventAdjustmentRetrieve>>>
export type FundFamilyEventAdjustmentRetrieveQueryError = unknown

export const useFundFamilyEventAdjustmentRetrieve = <TData = Awaited<ReturnType<typeof fundFamilyEventAdjustmentRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventAdjustmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyEventAdjustmentRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilyEventAdjustmentRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyEventAdjustmentRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventAdjustmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyEventAdjustmentRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyEventAdjustmentRetrieve>>> = ({ signal }) => fundFamilyEventAdjustmentRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventAdjustmentRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyEventAdjustmentRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventAdjustmentRetrieve>>>
export type FundFamilyEventAdjustmentRetrieveSuspenseQueryError = unknown

export const useFundFamilyEventAdjustmentRetrieveSuspense = <TData = Awaited<ReturnType<typeof fundFamilyEventAdjustmentRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventAdjustmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyEventAdjustmentRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilyEventAdjustmentRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilyEventAdjustmentRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => fundFamilyEventAdjustmentRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Adjusts a fund family event
 */
export const fundFamilyEventAdjustmentCreate = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilyEventAdjustmentCreateDataRequest: FundFamilyEventAdjustmentCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyEventData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event-admin/${fundFamilyEventId}/event-adjustment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fundFamilyEventAdjustmentCreateDataRequest
    },
      options);
    }
  


export const getFundFamilyEventAdjustmentCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventAdjustmentCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventAdjustmentCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventAdjustmentCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventAdjustmentCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyEventAdjustmentCreate>>, {fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventAdjustmentCreateDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,data} = props ?? {};

          return  fundFamilyEventAdjustmentCreate(fundFamilyId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyEventAdjustmentCreateMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventAdjustmentCreate>>>
    export type FundFamilyEventAdjustmentCreateMutationBody = FundFamilyEventAdjustmentCreateDataRequest
    export type FundFamilyEventAdjustmentCreateMutationError = unknown

    export const useFundFamilyEventAdjustmentCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventAdjustmentCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventAdjustmentCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyEventAdjustmentCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    